import { Result } from 'element-ui'

const YResult = Result
YResult.$depends = [Result]
YResult.$name = 'y-result'
YResult._name = 'Result 结果'

export default YResult
